"use client";

import { c as _c } from "react/compiler-runtime";
import GlossyCard from "@/components/card/glossy-card";
import { ibmPlexMono } from "@/config/fonts";
import { ADMIN_BANK_ACCOUNT_NUMBER, ADMIN_BANK_ACCOUNT_TITLE, ADMIN_BANK_IBAN, ADMIN_BANK_NAME } from "@/config/project-details";
import { copyTextToClipboard } from "@/utils/browser-utils";
import { formatPrice } from "@/utils/formatters";
import { cn } from "@/utils/helpers";
type PaymentAddressCardProps = {
  coursePrice: number;
  className?: string;
};
export default function PaymentAddressCard(t0) {
  const $ = _c(16);
  const {
    coursePrice,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("relative z-10 divide-y overflow-x-auto", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="flex flex-col gap-0.5 px-1 py-3 md:flex-row md:items-center md:gap-4"><p className="text-sm md:min-w-32 md:text-[15px]">Bank name:</p><p className={`${ibmPlexMono.className} text-2xl font-bold`} onClick={_temp}>{ADMIN_BANK_NAME}</p></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="flex flex-col gap-0.5 px-1 py-3 md:flex-row md:items-center md:gap-4"><p className="text-sm md:min-w-32 md:text-[15px]">Account title:</p><p className={`${ibmPlexMono.className} text-2xl font-bold`} onClick={_temp2}>{ADMIN_BANK_ACCOUNT_TITLE}</p></div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="flex flex-col gap-0.5 px-1 py-3 md:flex-row md:items-center md:gap-4"><p className="text-sm md:min-w-32 md:text-[15px]">Account number:</p><p className={`${ibmPlexMono.className} text-2xl font-bold`} onClick={_temp3}>{ADMIN_BANK_ACCOUNT_NUMBER}</p></div>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="flex flex-col gap-0.5 px-1 py-3 md:flex-row md:items-center md:gap-4"><p className="text-sm md:min-w-32 md:text-[15px]">IBAN:</p><p className={`${ibmPlexMono.className} text-2xl font-bold`} onClick={_temp4}>{ADMIN_BANK_IBAN}</p></div>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <p className="text-sm md:min-w-32 md:text-[15px]">Amount:</p>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  let t8;
  if ($[7] !== coursePrice) {
    t7 = () => copyTextToClipboard(coursePrice.toString(), "Amount copied to the clipboard.");
    t8 = formatPrice(coursePrice);
    $[7] = coursePrice;
    $[8] = t7;
    $[9] = t8;
  } else {
    t7 = $[8];
    t8 = $[9];
  }
  let t9;
  if ($[10] !== t7 || $[11] !== t8) {
    t9 = <div className="flex flex-col gap-0.5 px-1 py-3 md:flex-row md:items-center md:gap-4">{t6}<p className={`${ibmPlexMono.className} text-2xl font-bold`} onClick={t7}>{t8}</p></div>;
    $[10] = t7;
    $[11] = t8;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== t1 || $[14] !== t9) {
    t10 = <GlossyCard className="mx-auto max-w-2xl"><div className={t1} id="payment-address">{t2}{t3}{t4}{t5}{t9}</div></GlossyCard>;
    $[13] = t1;
    $[14] = t9;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  return t10;
}

// Recycled

// 14 May 2025

// courseVariant?: TGlobalStaticContent["courses"][number]["variants"][number];

// {courseVariant ? (
//   <>
//     <div className={`${ibmPlexMono.className} flex items-center gap-3 text-2xl font-bold`}>
//       <span>{formatPrice(coursePrice + courseVariant.additionalPrice)}</span>
//       <Badge variant="green">{courseVariant.label} Plan</Badge>
//     </div>

//     {/* INFO: use the following snippet to show all variants instead of just the selected one */}
//     {/* <div className={`${ibmPlexMono.className} flex flex-col gap-3 text-2xl font-bold`}>
//     {courseStaticContent?.variants.map((variant, i) => {
//       return (
//         <div key={variant.id} className="flex items-center gap-3">
//           <span>{formatPrice(coursePrice + variant.additionalPrice)}</span>
//           <Badge variant={i === 0 ? "blue" : "green"}>{variant.label} Plan</Badge>
//         </div>
//       );
//     })}
//   </div> */}
//   </>
// ) : (
//   <p className={`${ibmPlexMono.className} text-2xl font-bold`}>{formatPrice(coursePrice)}</p>
// )}
function _temp4() {
  return copyTextToClipboard(ADMIN_BANK_IBAN, "IBAN copied to the clipboard.");
}
function _temp3() {
  return copyTextToClipboard(ADMIN_BANK_ACCOUNT_NUMBER, "Account number copied to the clipboard.");
}
function _temp2() {
  return copyTextToClipboard(ADMIN_BANK_ACCOUNT_TITLE, "Account title copied to the clipboard.");
}
async function _temp() {
  return copyTextToClipboard(ADMIN_BANK_NAME, "Bank name copied to the clipboard.");
}